import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MOMENT_DATE_FORMATS } from '@engagement/custom-date-adapter';

import { Color, Tile, TILE_TOKEN, TileId, TileType } from '@contact/upgrade';

import { EngagementCoreForRootModule } from './core/engagement-core-for-root.module';

@NgModule({
  imports: [EngagementCoreForRootModule.instance()],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EngagementForRootModule {
  static instance(options: { path: string }): ModuleWithProviders<EngagementForRootModule> {
    return {
      ngModule: EngagementForRootModule,
      providers: [
        {
          provide: TILE_TOKEN,
          useValue: {
            id: TileId.ENGAGEMENT,
            type: TileType.STANDARD,
            icon: 'tile_engagement',
            color: Color.ORANGE,
            platforms: {
              desktop: {
                path: options.path,
              },
            },
            activePlatform: 'desktop',
          } as Tile,
          multi: true,
        },

        {
          provide: MAT_DATE_LOCALE,
          useValue: 'en-GB',
        },

        {
          provide: MAT_DATE_FORMATS,
          useValue: MOMENT_DATE_FORMATS,
        },
      ],
    };
  }
}
